/*
    Render in Body Section of "collapsible-content.liquid" file
   
    Render using -> <script src="{{ 'em_collapsible-content.js' | asset_url }}" defer="defer"></script>
    

*/
            const allDetails = document.querySelectorAll("details")

allDetails.forEach((details) => {
    details.addEventListener("toggle", (e) => {
        if (details.open) {
            allDetails.forEach((details) => {
                if (details != e.target && details.open) {
                    details.open = false
                }
            })
        }
    })
})